import { useSelector } from "react-redux";
import UserCard from "src/components/UserCard";
import useSWR from "swr";
import Loading from "./Loading";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function FriendRequests() {
  const user = useSelector((state: any) => state.user);

  const { data, error, isLoading } = useSWR<
    {
      userId: string;
    }[]
  >(
    `${process.env.REACT_APP_API_URL}/users/friend/requests`,
    fetcher(user.token),
    {
      refreshInterval: 10000,
    }
  );

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {isLoading && <Loading />}
        {error && !isLoading && (
          <div style={{ textAlign: "center" }}>
            Někde se stala chyba, zkus to prosím později
          </div>
        )}
        {data &&
          data.map((user) => (
            <UserCard key={user.userId} userId={user.userId} />
          ))}
      </div>
    </>
  );
}
